import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { CartProvider } from "./context/CartContext";
import { AuthProvider } from "./context/AuthContext";
import { Header, MobileTopBar } from "./components/Header";
import { AuthModal } from "./components/AuthModal";
import { BottomNav } from "./components/BottomNav";
import { WhatsAppButton } from "./components/WhatsAppButton";
import OnboardingModal from "./components/OnboardingModal";
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import Cart from "./pages/Cart";
import Checkout from "./pages/Checkout";
import Profile from "./pages/Profile";
import { PaymentSuccess, PaymentCancel } from "./pages/Payment";
import { OrderDetail, OrdersList } from "./pages/Orders";
import { AdminAuthProvider, AdminLogin, AdminLayout } from "./pages/admin/AdminLayout";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminMenu from "./pages/admin/AdminMenu";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCoupons from "./pages/admin/AdminCoupons";
import AdminSettings from "./pages/admin/AdminSettings";
import AdminContact from "./pages/admin/AdminContact";
import AdminUsers from "./pages/admin/AdminUsers";
import AdminPayments from "./pages/admin/AdminPayments";
import AdminReviews from "./pages/admin/AdminReviews";
import AuthCallback from "./pages/AuthCallback";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/ContactUs";
import TermsConditions from "./pages/TermsConditions";
import RefundPolicy from "./pages/RefundPolicy";
import Footer from "./components/Footer";
import ScrollToTop from "./components/ScrollToTop";

function CustomerLayout({ children }) {
  return (
    <>
      <Header />
      <MobileTopBar />
      {children}
      <Footer />
      <OnboardingModal />
      <WhatsAppButton />
      <BottomNav />
      <AuthModal />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Handle Google OAuth callback synchronously during render — before any /auth/me runs
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<CustomerLayout><Home /></CustomerLayout>} />
      <Route path="/menu" element={<CustomerLayout><Menu /></CustomerLayout>} />
      <Route path="/cart" element={<CustomerLayout><Cart /></CustomerLayout>} />
      <Route path="/checkout" element={<CustomerLayout><Checkout /></CustomerLayout>} />
      <Route path="/payment/success" element={<CustomerLayout><PaymentSuccess /></CustomerLayout>} />
      <Route path="/payment/cancel" element={<CustomerLayout><PaymentCancel /></CustomerLayout>} />
      <Route path="/orders" element={<CustomerLayout><OrdersList /></CustomerLayout>} />
      <Route path="/orders/:id" element={<CustomerLayout><OrderDetail /></CustomerLayout>} />
      <Route path="/profile" element={<CustomerLayout><Profile /></CustomerLayout>} />
      <Route path="/privacy" element={<CustomerLayout><PrivacyPolicy /></CustomerLayout>} />
      <Route path="/contact" element={<CustomerLayout><ContactUs /></CustomerLayout>} />
      <Route path="/terms" element={<CustomerLayout><TermsConditions /></CustomerLayout>} />
      <Route path="/refund" element={<CustomerLayout><RefundPolicy /></CustomerLayout>} />
      <Route path="/auth/callback" element={<AuthCallback />} />
      <Route path="/admin" element={<AdminLogin />} />
      <Route element={<AdminLayout />}>
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/menu" element={<AdminMenu />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/payments" element={<AdminPayments />} />
        <Route path="/admin/reviews" element={<AdminReviews />} />
        <Route path="/admin/coupons" element={<AdminCoupons />} />
        <Route path="/admin/contact" element={<AdminContact />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <ScrollToTop />
        <AuthProvider>
          <AdminAuthProvider>
            <CartProvider>
              <AppRouter />
            </CartProvider>
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
